import React, { forwardRef, Fragment } from "react";
import propTypes from "prop-types";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { checkEmpty } from "services/utils/commonFunctions/CommonFunctions";

const DropdownFilter = forwardRef(
  (
    {
      value = "",
      onChange,
      label,
      onBlur,
      disabled = false,
      required = false,
      isError = false,
      name,
      icon = null,
      suggestion = null,
      verified = false,
      placeholder = "",
      optionList = [],
      optValueKey = null,
      optIdKey = null,
      isIcon = false,
      hideSelectOne = false,
      hiddentrueVal="",
      isDashboard = false,
    },
    ref
  ) => (
    <div
      className={`form-group ${isIcon ? "" : ""} ${
        isError ? "error-text" : ""
      }` }
      ref={ref}
    >
      {icon !== null ? (
        <span className="icon">
          <img src={icon} alt="" />
        </span>
      ) : null}
      <select
        name={name}
        className="form-select"
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        onBlur={onBlur}
        disabled={disabled}
      >
        {placeholder ? (
          <option key="8" value="" hidden>{placeholder}</option>
        ) : (
          <option key="8" value="" hidden>
            {localization.selected}
          </option>
        )}
      
        {!checkEmpty(optionList)
          ? optionList.map((response) => {
              return (
                <Fragment key={response[optIdKey]}>
                  {response[optValueKey] !== null ? (
                    <option value={response[optIdKey]} >
                      {response[optValueKey]}
                    </option>
                  ) : null}
                </Fragment>
              );
            })
          : null}
      </select>
      <label className="placeholder">
        {label}
        {required ? null : null}
      </label>
      {suggestion !== null ? (
        <span className="help-text">{suggestion}</span>
      ) : null}
      {verified ? (
        <span className="verified d-block">
          <img src={isError ? Images?.alertCircle : Images?.verified} alt="" />
        </span>
      ) : null}
    </div>
  )
);

DropdownFilter.propTypes = {
  value: propTypes.oneOfType([
    propTypes.object,
    propTypes.string,
    propTypes.number,
  ]),
  onChange: propTypes.func,
  label: propTypes.oneOfType([propTypes.string, propTypes.object]),
  name: propTypes.oneOfType([
    propTypes.string,
    propTypes.object,
    propTypes.number,
  ]),
};

export default DropdownFilter;
